<template>
  <div class="g-bd">
    <div class="con-list f-clearfix">
      <div class="us-msg">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="关于我们" name="1"></el-tab-pane>
          <el-tab-pane label="联系方式" name="2"></el-tab-pane>
          <el-tab-pane label="帮助中心" name="3"></el-tab-pane>
          <div v-if="activeName == 1">
            <div v-html="form.introduction"></div>
          </div>
          <div v-else-if="activeName == 2">
            <div v-html="form.contact_info"></div>
          </div>
          <div v-else>
            <ul v-if="detailMsg" class="help">
              <li
                v-for="(item, index) in list"
                :key="index"
                class="help-list"
                @click="itemDetail(item)"
              >
                <span class="help-list-index"></span> {{ item.title }}
              </li>
              <div class="m-pagination-wrapper">
                <el-pagination
                  class="m-pagination"
                  @current-change="changePage"
                  :page-size="pageList.pageSize"
                  :hide-on-single-page="true"
                  :current-page.sync="pageList.pageNo"
                  :total="pageList.total"
                  layout=" prev, pager, next"
                ></el-pagination>
              </div>
            </ul>
            <div class="details" v-else>
              <h3>{{ detail.title }}</h3>
              <div v-html="detail.details"></div>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "1",
      form: {},
      list: [],
      detailMsg: true,
      uploadUrl: this.$setting.baseURL + "/api/oss/upload/upload",
      imgUrl: this.$setting.fdsDomain,
      pageList: {
        pageNo: 1,
        pageSize: 30,
        total: 0,
      },
      detail: "",
    };
  },
  mounted() {
    this.getList();
    this.getInfo();
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
  },
  methods: {
    changePage(val) {
      this.pageList.pageNo = val;
      this.getList();
    },
    itemDetail(item) {
      this.$http
        .post("/api/web/help/get", { id: item.id })
        .then((res) => {
          this.detail = res.data;
          this.detailMsg = false;
        })
        .catch((msg) => {
          this.$message.error(msg);
        });
    },
    saveUser() {
      this.$http
        .post("/api/web/user/update", this.addForm)
        .then((data) => {
          this.$message.success(data.message);
          console.log(this.$store.state.user_info);
        })
        .catch((msg) => {});
    },
    getInfo() {
      this.$http
        .post("/api/manage/config/getConfig")
        .then((data) => {
          this.form = data.data;
        })
        .catch((msg) => {});
    },
    getList() {
      let par = {
        pageSize: this.pageList.pageSize,
        currentPage: this.pageList.pageNo,
      };
      this.$http
        .post("/api/web/help/list", par)
        .then((res) => {
          this.pageList.total = res.data.total;
          this.pageList.pageNo = res.data.current;
          this.list = res.data.records;
        })
        .catch((msg) => {});
    },
    handleClick(tab) {
      this.detailMsg = true;
      this.$router.push({
        path: "/usIndex",
        query: {
          activeName: tab.name,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.us-msg {
  background: #ffffff;
  border-radius: 8px;
  width: 1040px;
  min-height: 852px;
  margin: 35px auto;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 15px 30px;
}
.el-form-item {
  margin-bottom: 0;
}
.help {
  margin-top: -15px;
  .help-list {
    font-size: 16px;
    line-height: 16px;
    padding: 29px 0;
    cursor: pointer;
    border-bottom: 1px solid rgba(242, 242, 242, 1);
    .help-list-index {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #aaaaaa;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}
.details {
  h3 {
    height: 17px;
    font-size: 16px;
    line-height: 16px;
    margin: 28px 0;
    font-weight: 600;
  }
  /deep/img {
    width: 100%;
  }
}
/deep/.el-tabs__header {
  margin: 0 0 30px;
}
</style>